export default "__VITE_ASSET__CZgx4rip__"